import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=95b7b7ea&scoped=true"
import script from "./ShiftReport.vue?vue&type=script&lang=js"
export * from "./ShiftReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b7b7ea",
  null
  
)

export default component.exports